import DailyInputChart from '@/modules/Report/components/SalePerformances/components/DailyInputChart'
import { CustomerPipelineFilters } from '@/modules/Report/components/SalePerformances/types'
import useAuthStore from '@/stores/useAuthStore'
import dayjs from 'dayjs'
import { useMemo } from 'react'

const DailyInputWidget: React.FC = () => {
    const { employee } = useAuthStore()
    const today = dayjs()
    const filters: CustomerPipelineFilters = useMemo(
        () => ({
            gte: today.subtract(30, 'day').format('YYYY-MM-DD'),
            lte: today.format('YYYY-MM-DD'),
            sales_manager_codes: employee?.employee_id?.toString() || '',
        }),
        [today]
    )

    return (
        <div className="h-full">
            <DailyInputChart
                filters={filters}
                viewTable={false}
                className="h-full"
            />
        </div>
    )
}

export default DailyInputWidget
